import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import App from "./App";

// Owner admin area — a hidden, unlisted route (see README → Admin area). Lazy so the
// portfolio bundle doesn't carry supabase-js/bootstrap for normal visitors, and so the
// path itself never appears in the main bundle: the first path segment is matched by
// hash, and the literal lives only inside the admin chunk, which nothing else loads.
// (Unlisted, not secret — the chunk is still public; sign-in is the real boundary.)
const AdminShell = lazy(() => import("./admin/AdminShell"));

function hash(str) {
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((Math.imul(h, 33) ^ str.charCodeAt(i)) >>> 0);
  return h;
}
const isAdminRoute = hash(window.location.pathname.split("/")[1] || "") === 2842272568;

ReactDOM.render(
  isAdminRoute ? (
    <Suspense fallback={null}>
      <AdminShell />
    </Suspense>
  ) : (
    <App />
  ),
  document.getElementById("root")
);
